import React from "react";
import { FaShieldAlt, FaUserSecret, FaUniversity } from "react-icons/fa";
const AboutUs = () => {
  return (
   

<>
<section className="bg-[#02042b] py-28 mt-0">
      <div className="max-w-6xl mx-auto px-6 text-center">
        {/* Section 1: Welcome */}
        <div className="mb-12">
          <h3 className="text-4xl font-bold text-white">
            Welcome to <span className="bg-gradient-to-r from-blue-300 via-blue-400 to-blue-500 text-transparent bg-clip-text">Infinite Solution</span>
          </h3>
          <p className="mt-4 text-gray-200 leading-relaxed">
            Infinite Solution is committed to offering top-notch academic and technical support services.
            Established with the goal of helping students, educators, and professionals succeed, we take
            pride in providing expertly crafted, original work and professional technical solutions.
          </p>
        </div>

        {/* Section 2: Countries Served */}
        <div className="mb-12">
          <h3 className="text-3xl font-semibold text-white">
            Serving 15+ <span className="bg-gradient-to-r from-yellow-300 via-yellow-400 to-yellow-500 text-transparent bg-clip-text font-bold">Countries</span> Worldwide
          </h3>
          <div className="flex flex-wrap justify-center mt-6 gap-4">
            {[
              "https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg",
              "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg",
              "https://upload.wikimedia.org/wikipedia/commons/b/b9/Flag_of_Australia.svg",
              "https://upload.wikimedia.org/wikipedia/en/c/cf/Flag_of_Canada.svg",
              "https://upload.wikimedia.org/wikipedia/en/b/ba/Flag_of_Germany.svg",
              "https://upload.wikimedia.org/wikipedia/commons/4/45/Flag_of_Ireland.svg",
              "https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg",
            ].map((flag, index) => (
              <img key={index} src={flag} alt="Flag" className="w-12 h-8 rounded shadow-lg" />
            ))}
          </div>
        </div>

        {/* Section 3: CEO Introduction */}
     {/* Section 3: CEO Introduction */}
<div className="bg-gradient-to-r from-purple-600 to-indigo-800 text-white shadow-lg rounded-lg p-8 mx-auto max-w-3xl">
  <p className="text-white leading-relaxed font-medium">
    Digital disruption has reshaped education and technology, making content and innovation the
    keys to growth. At Infinite Solution, we are passionate about revolutionizing learning.
  </p>
  <div className="mt-4">
    <p className="text-lg font-semibold">
      Welcome to our creation! I am <strong className="text-yellow-400">Joy, CEO & Co-founder</strong>,
      alongside <strong className="text-yellow-400">Debjit, our visionary CEO & Founder</strong>.
    </p>
  </div>
  <p className="mt-4 text-white font-medium">
    We are dedicated to shaping bright futures, whether through educational consultancy,
    tutoring, or mentoring. Join us and experience the delight of revolution and excellence.
  </p>
</div>
</div>
    </section>


<section className="bg-[#02042b]  py-12 mb-0">
<div className="max-w-6xl mx-auto px-4 sm:px-6">

  {/* Quick Links Section */}
  <div className="mb-12 text-center">

    <h3 className="text-2xl sm:text-3xl font-bold text-white">
      Why Choose
      <span className="ml-2 bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-600 text-transparent bg-clip-text">
        Infinite Solution?
      </span>
    </h3>

    <p className="mt-3 sm:mt-4 text-gray-300 leading-relaxed text-sm sm:text-base">
      We are committed to providing top-tier research guidance, academic support,
      and technical solutions worldwide.
    </p>

    <div className="mt-6 flex flex-wrap justify-center gap-3 sm:gap-4">

      {[
        { title: "Our Writers", link: "/aboutus" },
        { title: "Our Guarantees", link: "/aboutus" },
        { title: "Procedures", link: "/aboutus" },
        { title: "Work With Us", link: "/aboutus" },
        { title: "Our Process", link: "/aboutus" },
        { title: "Contact Us", link: "/aboutus" },
      ].map((item, index) => (
        <a
          key={index}
          href={item.link}
          className="text-white text-sm sm:text-base bg-gradient-to-r from-blue-400 to-blue-600 font-semibold px-3 sm:px-4 py-2 rounded-lg shadow hover:opacity-90 transition duration-300"
        >
          {item.title}
        </a>
      ))}

    </div>
  </div>



{/* Core Sections */}
<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">

  {/* Vision & Mission */}
  <div className="bg-gradient-to-br from-teal-500 via-teal-600 to-teal-700 text-gray-800 shadow-lg rounded-2xl p-5 sm:p-6 transition-transform duration-300 hover:scale-[1.02] hover:shadow-2xl">
    <div className="flex items-start sm:items-center gap-3 mb-3">
      <FaUniversity className="text-white text-4xl sm:text-5xl" />
      <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white leading-tight">
        Vision & Mission
      </h3>
    </div>

    <p className="leading-relaxed text-white text-sm sm:text-base font-medium">
      Infinite Solution aims to be the world's leading provider of academic and technical
      guidance, serving clients globally with expertise and integrity.
    </p>
  </div>

  {/* Infrastructure & Security */}
  <div className="bg-gradient-to-br from-indigo-600 via-indigo-700 to-indigo-800 shadow-lg rounded-2xl p-5 sm:p-6 transition-transform duration-300 hover:scale-[1.02] hover:shadow-2xl">
    <div className="flex items-start sm:items-center gap-3 mb-3">
      <FaShieldAlt className="text-white text-4xl sm:text-5xl" />
      <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white leading-tight">
        Infrastructure & Security
      </h3>
    </div>

    <p className="leading-relaxed text-white text-sm sm:text-base font-medium">
      Our state-of-the-art infrastructure includes 24/7 power backup, high-speed internet,
      secure data storage, and access to premium research databases.
    </p>
  </div>

  {/* Confidentiality & Privacy */}
  <div className="bg-gradient-to-br from-orange-600 via-orange-700 to-red-800 shadow-lg rounded-2xl p-5 sm:p-6 transition-transform duration-300 hover:scale-[1.02] hover:shadow-2xl">
    <div className="flex items-start sm:items-center gap-3 mb-3">
      <FaUserSecret className="text-white text-4xl sm:text-5xl" />
      <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-white leading-tight">
        Confidentiality & Privacy
      </h3>
    </div>

    <p className="leading-relaxed text-white text-sm sm:text-base font-medium">
      We protect your research data with the highest security standards. Our team signs NDAs,
      ensuring complete confidentiality of your work.
    </p>
  </div>

</div>


</div>
</section>

<section className="bg-[#02042b] py-3 sm:py-8">
  <div className="max-w-6xl mx-auto px-4 sm:px-6">

    {/* Heading */}
    <div className="text-center">
      <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white">
        Our{" "}
        <span className="bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-600 text-transparent bg-clip-text">
          Services
        </span>
      </h3>

      <p className="text-gray-300 mt-3 text-sm sm:text-base max-w-2xl mx-auto">
        We provide expert academic support, research guidance, and development services.
      </p>
    </div>

    {/* Services Grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mt-10">
      {services.map((service, index) => (
        <a
          key={index}
          href={service.link}
          className="group bg-gray-800/90 rounded-xl overflow-hidden shadow-lg border border-gray-700 hover:border-yellow-500 transition-all duration-300"
        >
          <div className="relative w-full h-44 sm:h-52 lg:h-56 overflow-hidden">
            <img
              src={service.img}
              alt={service.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          </div>

          <div className="p-4 sm:p-5 text-center">
            <h4 className="text-white font-semibold text-base sm:text-lg group-hover:text-yellow-400 transition-colors duration-300">
              {service.title}
            </h4>
          </div>
        </a>
      ))}
    </div>

  </div>
</section>



   <section className="py-16 sm:py-20 bg-[#02042b]">
  {/* Heading */}
  <div className="max-w-6xl mx-auto text-center px-4 sm:px-6">
    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-600">
      Range of Our Academic & Assignment Writing Options
    </h2>

    <p className="text-gray-200 mt-3 text-sm sm:text-base max-w-3xl mx-auto leading-relaxed">
      We provide one of the <span className="font-semibold">best assignment writing solutions.</span>  
      However, our <span className="font-semibold">writing assistance</span> is not limited to assignments alone —  
      we also cover multiple academic formats and disciplines.
    </p>
  </div>

  {/* Cards */}
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 sm:gap-6 max-w-6xl mx-auto mt-10 px-4 sm:px-6">
    {academicTopics.map((item) => (
      <div
        key={item.uniqueId}
        className="bg-blue-500/20 border border-blue-400/20 rounded-2xl p-6 shadow-md hover:shadow-xl
                   transition-all duration-300 flex flex-col items-center text-center hover:bg-blue-500/30"
      >
        <a href={item.url} target="_blank" rel="noopener noreferrer" className="block">
          <img
            src={item.imageSource}
            alt={item.heading}
            className="w-14 h-14 sm:w-16 sm:h-16 mb-4 object-contain"
          />
        </a>

        <h4 className="text-base sm:text-lg font-bold text-[#FFFECE]">
          <a
            href={item.url}
            className="hover:text-blue-300 transition"
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.heading}
          </a>
        </h4>
      </div>
    ))}
  </div>
</section>


<div className="container mx-auto px-6 py-20 mb-0 bg-gradient-to-b from-[#02042b] via-[#05183d] to-[#0b2c67]">
  <p className="text-center text-blue-200 uppercase font-bold text-lg tracking-wider">Subjects We Cover</p>
  <h2 className="text-center pb-2 text-4xl font-bold bg-gradient-to-r from-yellow-200 via-yellow-400 to-yellow-600 text-transparent bg-clip-text mt-2 mb-8">
    A broad range of academic fields.
  </h2>

  <div className="flex flex-col lg:flex-row gap-8 mt-10">
    {subjects.map((subject, index) => (
      <div
        key={index}
        className="bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 p-6 rounded-lg shadow-xl flex-1 border border-blue-300/50 hover:scale-105 transition-transform"
      >
      <h2 className="text-3xl font-extrabold text-gray-50 underline">
  {subject.title}
</h2>

        <div className="mt-4 space-y-4">
          {subject.categories.map((category, i) => (
            <div key={i}>
       <p className="text-transparent bg-clip-text bg-yellow-200 text-2xl font-extrabold drop-shadow-md">
  {category.name}
</p>
<p className="text-white font-semibold text-md  drop-shadow-sm">
  {category.items.join(", ")}
</p>


            </div>
          ))}
        </div>
        <a
          href={subject.link}
          className="inline-block mt-6 px-5 py-2 bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white font-semibold rounded-lg shadow-md transition-all duration-300"
        >
          View Samples
        </a>
      </div>
    ))}
  </div>
</div>



</>
  );
};

const subjects = [
  {
    title: "Non Technical Subjects",
    categories: [
      { name: "Management", items: ["Economics", "Leisure Management", "Human Resource", "Housing", "Operations", "Estate Management", "Human Resource Management", "Marketing", "Research Methodology", "Human Rights", "International Relations", "Business", "Project Management", "Small Business Enterprise"] },
      { name: "Finance", items: ["Statistics", "Financial Management", "Accounts", "Commerce", "Eviews", "SAS", "NVIVO", "SPSS"] },
      { name: "Law", items: ["Law", "Legal Aspects", "Business Law"] },
      { name: "Tourism", items: ["Travel & Tourism", "Food", "Tourism", "Hospitality"] },
      { name: "Health", items: ["Healthcare", "Health & Social Care", "Pharmacy", "Medical", "Childcare", "Nursing", "Physiology", "Physical Education", "Biotechnology"] },
      { name: "Arts and Humanities", items: ["Social Policy", "Social Work", "Sociology", "Sports", "Theology", "Psychology", "Arts", "Criminology", "Environmental Studies", "General Studies", "Geography", "History", "Anthropology", "Religion", "Politics", "Philosophy", "Geology"] },
      { name: "Culture and Drama", items: ["Theatre", "Journalism", "Film Studies", "Photography", "Film Review", "Drama", "Cultural Studies", "Media", "Music"] },
    ],
    link: "https://drive.google.com/drive/folders/1fCS-QRridb1TQxwIgtGvdC95eEYrMQ6P"
  },
  {
    title: "Technical Subjects",
    categories: [
      { name: "Science", items: ["Mechanics", "Chemistry", "Physics", "Mathematics", "Information Technology", "Computer Science", "Biology", "Architecture", "Construction"] },
      { name: "Engineering", items: ["Aerospace Engineering", "Mechanical Engineering", "Industrial Engineering", "Electrical Engineering", "Electronic Engineering", "Material Science Engineering", "Chemical Engineering", "Civil Engineering", "Oil and Gas Engineering", "IT Engineering", "Computer Science"] },
      { name: "Computer Science", items: ["C++", "Python", "Java", "JavaScript", "Data Structures", "Computer Networking", "Automata", "Compiler Design", "SQL"] },
      { name: "Programming", items: ["IT-Networking", "Operating System", "Data Mining", "Other Programming", "iOS Application", "Android Application", "Web Application", "Simulation", "Data Visualization", "Data Modeling", "Database / SQL", "Animation"] },
      { name: "Software Skills", items: ["Advanced Excel", "AutoCAD", "Linux", "Ethical Hacking", "Matlab Simulink", "Minitab", "StarUML"] },
      { name: "UI/UX and Designing", items: ["User Interface (UI) Design", "User Experience (UX) Design", "Graphic Design", "Web Design", "Visual Design", "Information Architecture (IA)", "Usability Testing", "User Research", "Typography", "Color Theory", "Design Thinking", "UI/UX Prototyping", "User Experience (UX) Writing", "Accessibility"] },
      { name: "Networking", items: ["Kali Linux", "Linux", "Ubuntu", "Cisco", "Wireshark", "Nmap", "autoSpy", "Computer Forensics"] },
      { name: "Analysis", items: ["Weka", "Stata", "SPSS", "EViews"] },
      { name: "Data Mining", items: ["Orange", "RapidMiner", "SAS", "Jamovi"] },
      { name: "Data Analysis", items: ["Python (Machine Learning and Data Science)", "Spyder", "PySpark", "R-Studio"] },
      { name: "Data Visualization", items: ["Power BI", "Tableau"] },
      { name: "Database", items: ["MySQL"] },
      { name: "Windows", items: ["Windows Terminal", "Windows PowerShell"] },
      { name: "GIS", items: ["ArcGIS", "QGIS"] },
    ],
    link: ""
  }
];


const academicTopics = [
  {
    uniqueId: 1,
    heading: "Dissertation Writing Services",
    url: "",
    imageSource: "https://contentholic.com/wp-content/uploads/2023/01/thesis.png",
  },
  {
    uniqueId: 2,
    heading: "Thesis Writing Help",
    url: "",
    imageSource: "https://contentholic.com/wp-content/uploads/2023/01/dissertation.png",
  },
  {
    uniqueId: 3,
    heading: "Essay Writing Services",
    url: "",
    imageSource: "https://contentholic.com/wp-content/uploads/2023/01/abstracts.png",
  },
  {
    uniqueId: 4,
    heading: "Abstract Writing Services",
    url: "",
    imageSource: "https://contentholic.com/wp-content/uploads/2023/01/book-report.png",
  },
  {
    uniqueId: 5,
    heading: "Book Report Writing",
    url: "",
    imageSource: "https://contentholic.com/wp-content/uploads/2023/01/term-papers.png",
  },
  {
    uniqueId: 6,
    heading: "Book Review Writing",
    url: "",
    imageSource: "https://contentholic.com/wp-content/uploads/2023/01/book-review.png",
  },
  {
    uniqueId: 7,
    heading: "Term Paper Writing",
    url: "",
    imageSource: "https://contentholic.com/wp-content/uploads/2023/01/conference-papers.png",
  },
  {
    uniqueId: 8,
    heading: "Online Exam Help",
    url: "",
    imageSource: "https://contentholic.com/wp-content/uploads/2023/07/sop-writing-s.png",
  },
  {
    uniqueId: 9,
    heading: "Research Paper Writing",
    url: "",
    imageSource: "https://contentholic.com/wp-content/uploads/2023/01/research-papers.png",
  },
  {
    uniqueId: 10,
    heading: "CDR Writing Services",
    url: "",
    imageSource: "https://contentholic.com/wp-content/uploads/2024/02/CDR-Writing-Services.png",
  },
  {
    uniqueId: 11,
    heading: "Case Study Assignment",
    url: "",
    imageSource: "https://contentholic.com/wp-content/uploads/2024/02/Case-Study-Assignment.png",
  },
  {
    uniqueId: 12,
    heading: "Reflective Writing",
    url: "",
    imageSource: "https://contentholic.com/wp-content/uploads/2024/02/Reflective-Writing-Assignment.png",
  },
];


const services = [
  {
    title: "Masters Dissertation Writing",
    img: "https://www.tutorsindia.com/wp-content/uploads/2024/08/Writing-services.webp",
    link: "/aboutus",
  },
  {
    title: "PhD/DBA Dissertation",
    img: "https://www.tutorsindia.com/wp-content/uploads/2024/08/Phd-dba-writing.webp",
    link: "/aboutus",
  },
  {
    title: "Coursework Writing",
    img: "https://www.tutorsindia.com/wp-content/uploads/2024/08/coursework-writing.webp",
    link: "/aboutus",
  },
  {
    title: "Publication Support",
    img: "https://www.tutorsindia.com/wp-content/uploads/2024/08/publication-services.webp",
    link: "/aboutus",
  },
  {
    title: "Development",
    img: "https://www.tutorsindia.com/wp-content/uploads/2024/08/Development.webp",
    link: "/aboutus",
  },
  {
    title: "Editing Services",
    img: "https://www.tutorsindia.com/wp-content/uploads/2024/08/Editing-services-1.webp",
    link: "/aboutus",
  },
];

export default AboutUs;
